module.exports = __webpack_public_path__ + "img/score.37509eab.png";